import React from "react";
export function withModel(useModelOrUseModels, mapModelToProps) {
  return function (C) {
    var Wrapper = function Wrapper(props) {
      var modelProps;

      if (Array.isArray(useModelOrUseModels)) {
        var models = [];
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = useModelOrUseModels[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var useModel = _step.value;
            models.push(useModel());
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }

        modelProps = mapModelToProps(models, props);
      } else {
        var model = useModelOrUseModels();
        modelProps = mapModelToProps(model, props);
      }

      var componentProps = Object.assign(Object.assign({}, props), modelProps);
      return React.createElement(C, Object.assign({}, componentProps));
    };

    Wrapper.displayName = "".concat(C.displayName, "Wrapper");
    return Wrapper;
  };
}